var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.05 33.6 14.7-14.7L33 16.2 21.05 28.15 15 22.1l-2.7 2.7ZM24 44.8q-4.3 0-8.075-1.65-3.775-1.65-6.6-4.475Q6.5 35.85 4.85 32.05 3.2 28.25 3.2 24q0-4.3 1.65-8.1t4.475-6.625q2.825-2.825 6.625-4.45T24 3.2q4.3 0 8.1 1.625t6.625 4.45q2.825 2.825 4.45 6.625t1.625 8.15q0 4.25-1.625 8.025-1.625 3.775-4.45 6.6Q35.9 41.5 32.1 43.15 28.3 44.8 24 44.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDone);
export default __webpack_public_path__ + "static/media/ic_done.2ccce429d8ea0be75fe8ba671f9cf64c.svg";
export { ForwardRef as ReactComponent };